import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class UserService {

    constructor(private http: HttpClient) { }

    getContributorSelectItems(): Observable<Array<SelectListItemModel>> {
        return this.http.get<Array<SelectListItemModel>>(`${environment.apiUrl}/api/chief-editor/user/contributor/select-items`);
    }

    getEditorList(unixTimeStamp: number): Observable<Array<SelectListItemModel>> {
        return this.http.get<Array<SelectListItemModel>>(`${environment.apiUrl}/api/chief-editor/user/list-editor/${unixTimeStamp}`);
    }
}
